export function findComponentOnCanvas(key) {
  const Collection = this.getCanvasCollection()
  return Collection?.lookdown((el) => {
    return el.state?.key === key && el.Flex
  })
}

export function findWhereItsUsedOnCanvas(key) {
  const Collection = this.getCanvasCollection()
  return Collection.lookdownAll((el) => el?.state?.uses?.includes(key))
}

export async function refreshComponentsWhereReferencedOnCanvas(key, opts) {
  const foundInOtherComponents = this.findWhereItsUsedOnCanvas(key)
  if (foundInOtherComponents) {
    await foundInOtherComponents.forEach(async (v) => {
      if (v.Flex) {
        await v.update({}, { forceReset: true, ...opts })
      }
    })
  }
}

export async function refreshComponentOnCanvas(key, obj, opts = {}) {
  const activeElement = this.findComponentOnCanvas(key)
  if (!activeElement) {
    return this.warn('Cant find on canvas')
  }

  try {
    await activeElement.state.replace(obj, {
      forceReset: true,
      onError: opts.onError
    })
  } catch (e) {
    opts.onError?.(e)
  }

  await this.call('refreshComponentsWhereReferencedOnCanvas', key, opts)
}

export function queueUpdateItemInCanvas(key) {
  const data = this.getCanvasScope()
  if (!data.queueToUpdate) {
    data.queueToUpdate = []
  }
  if (data.queueToUpdate.indexOf(key) === -1) {
    data.queueToUpdate.push(key)
  }
}

export async function refreshCanvasComponentsQueue() {
  const data = this.getCanvasScope()
  const { queueToUpdate } = data
  if (!queueToUpdate || !queueToUpdate.length) {
    return
  }
  queueToUpdate.forEach((key) => {
    const type = this.getType(key)
    this.call('updateItemInCanvas', type, key)
  })
  data.queueToUpdate = []
}

export function checkIfReferencedInOtherCanvasItems(type, key) {
  const usedInComponents = Object.values(this.getSchema('components'))
    .filter((v) => v.uses?.includes(key))
    .map((v) => v.key)
  const usedInPages = Object.values(this.getSchema('pages'))
    .filter((v) => v.uses?.includes(key))
    .map((v) => v.key)
  const usedIn = usedInComponents.concat(usedInPages)
  const confirmDeps = `Component is used in "${usedIn.join(', ')}" ${type.slice(
    0,
    -1
  )}, do you want to remove it anyway?`
  if (usedIn.length && !window.confirm(confirmDeps)) {
    return false
  }
  return usedIn
}

export async function openComponent(opts = {}) {
  const { props, state } = this
  const { value, extend } = state
  let key = value || state.key
  if (extend) {
    key = Array.isArray(extend) ? extend[0] : extend
  }
  if (props?.extend) {
    key = props.extend
  }
  const type = this.getType(key)
  if (!type) {
    return
  }
  const SMBLS_COMPONENT = this.context[type][key]
  const PROJECT_COMPONENT = this.getItem(key)
  let isComponent =
    this.call('checkIfKeyIsComponent', key) &&
    (SMBLS_COMPONENT || PROJECT_COMPONENT)
  if (!isComponent) {
    const DEFAULT_COMPONENT = await this.getDefaultComponents()[key]
    if (DEFAULT_COMPONENT) {
      isComponent = DEFAULT_COMPONENT
    } else {
      return
    }
  }
  const s = this.getCanvasCollection()?.lookdown((el) => el.state?.key === key)
  if (s) {
    this.activateSelected(s)
  }
  if (!opts.chosenOnCmd && !this.getRootState('isModifierPressed')) {
    this.activateChosen(s)
  }
}
